import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Modal,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  TextField,
  Slider,
  Autocomplete
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import AutorenewIcon from "@mui/icons-material/Autorenew";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";


const loaderStyle = {
  width: "18px",
  height: "18px",
  marginTop:'4px',
  border: "3px solid #e5e7eb",       // light gray background circle
  borderTop: "3px solid #0ea5e9",     // sky blue spinning arc
  borderRadius: "50%",               // circle
  animation: "spin 1s linear infinite",
  display: "inline-block",
};


const getcurrentRunningJobIcon = (status) => {
  switch (status.toUpperCase()) {
    case "PENDING":
      return <HourglassEmptyIcon style={{ color: "#facc15" }} />; // Yellow
    case "IN_PROGRESS":
      return <div style={loaderStyle}></div>;
    case "CANCELLED":
      return <CancelIcon style={{ color: "#dc2626" }} />; // Red
    case "COMPLETED":
      return <CheckCircleIcon style={{ color: "#16a34a" }} />; // Green
    case "DO":
      return <PlayArrowIcon style={{ color: "#3b82f6" }} />; // Blue
    case "PAUSED":
      return <PauseCircleIcon style={{ color: "#f97316" }} />; // Orange
    default:
      return <HelpOutlineIcon style={{ color: "#9ca3af" }} />; // Gray
  }
};



export const Tasks = ({
  tasksList,
  setectedAgentJobDetail,
  handleTaskAssign,
  handleAgentStatus,
  userRequests,
  selectedTask,
  setSelectedTask
}) => {
  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [error, setError] = useState({
    type: '',
    message: ''
  });
  const [formData, setFormData] = useState({});

  const handleInputChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleOpen = (task) => {
    setSelectedTask(task)
    if (task && Object.keys(task).length > 0 && task?.task_args && task?.task_args != null && Object.keys(task?.task_args).length > 0) {
      setFormData((
        Object.keys(task.task_args).reduce((acc, key) => {
          acc[key] = task.task_args[key].default;
          return acc;
        }, {})
      ))
    }
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedTask({})
    setOpen(false);
  };

  const getcurrentRunningJob = (task) => {
    const jobs = setectedAgentJobDetail?.jobs || [];
    const filteredList = jobs
      .filter(job => job.task_name === task.task_name)
      .sort((a, b) => b.job_id - a.job_id);
    return filteredList;
  }

  const validateForm = () => {
    let newErrors = {};

    if (selectedTask && Object.keys(selectedTask).length > 0 && selectedTask?.task_args && selectedTask?.task_args != null && Object.keys(selectedTask?.task_args).length > 0) {
      Object.entries(selectedTask?.task_args).forEach(([key, field]) => {
        if (!formData[key] || (Array.isArray(formData[key]) && formData[key].length === 0)) {
          newErrors[key] = `${field.label} is required`;
        }
      });
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    if (error?.type) {
      setTimeout(() => {
        setError({
          type: '',
          message: ''
        })
      }, 1000)
    }
  }, [error])


  const handleAssignTask = () => {
    if (validateForm()) {
      handleTaskAssign(selectedTask.task_name, formData);
      setFormData({})
      handleClose()
    } else {
      setError({ type: 'error', message: "Form validation failed. Please make sure all required fields are filled." });
    }
  }

  function checkTimeDifference(parsedData, storageDataName) {
    const assignedTime = new Date(parsedData.assigned_time); // Convert back to Date object
    const currentTime = new Date();

    const timeDifference = (currentTime - assignedTime) / 1000; // Difference in seconds

    if (storageDataName == "job_status_changed") {
      if (((parsedData.status == "PAUSE" && "IN_PROGRESS" == setectedAgentJobDetail.current_job_status) || (parsedData.status == "DO" && "PAUSED" == setectedAgentJobDetail.current_job_status) || (parsedData.status == "CANCEL" && "CANCELLED" == setectedAgentJobDetail.current_job_status))
        && parsedData.task_name == setectedAgentJobDetail.current_job_name
        && parsedData.agent_id == setectedAgentJobDetail.agent_unique_id
      ) {
        sessionStorage.removeItem(storageDataName)
        return true;
      }
    }
    if (timeDifference > 60) {
      sessionStorage.removeItem(storageDataName)
      return false;
    } else {
      return true;
    }
  }

  const handleDisableAssignButton = (task) => {
    let disableAssign = true;
    const taskData = sessionStorage.getItem('task_job_assigned');
    if (taskData) {
      const parsedData = JSON.parse(taskData);
      if (parsedData) {
        if (checkTimeDifference(parsedData, 'task_job_assigned')) {
          disableAssign = parsedData.task_name;
        }
      }
    } else {
      if (String(setectedAgentJobDetail?.current_job_status).toLowerCase() === 'completed' || String(setectedAgentJobDetail?.current_job_status).toLowerCase() === 'cancelled' || String(setectedAgentJobDetail?.current_job_status).toLowerCase() === 'failed' || !setectedAgentJobDetail?.current_job_status || setectedAgentJobDetail?.current_job_status == '' || !setectedAgentJobDetail?.current_job_id || setectedAgentJobDetail?.current_job_id == '') {
        disableAssign = false;
      }
    }
    return disableAssign;
  }

  const handleEnableCurrentRunningJob = (task) => {
    let disableAssign = true;
    if (task?.task_name == setectedAgentJobDetail?.current_job_name) {
      if (!(String(setectedAgentJobDetail?.current_job_status).toLowerCase() == 'completed') || !(String(setectedAgentJobDetail?.current_job_status).toLowerCase() == 'cancelled') || !(String(setectedAgentJobDetail?.current_job_status).toLowerCase() === 'failed') || !setectedAgentJobDetail?.current_job_status) {
        disableAssign = false;
      }
    }
    if (setectedAgentJobDetail?.current_job_status || setectedAgentJobDetail?.current_job_status != '') {
      const taskData = sessionStorage.getItem('job_status_changed');
      if (taskData) {
        const parsedData = JSON.parse(taskData);
        if (parsedData && parsedData.agent_id == setectedAgentJobDetail.agent_unique_id && parsedData.task_name == task.task_name) {
          if (checkTimeDifference(parsedData, 'job_status_changed')) {
            disableAssign = parsedData.status;
          }
        }
      }
    }
    return disableAssign;
  }

  const getTasksLastJob = (taskName) => {
    let jobs = setectedAgentJobDetail?.jobs;
    if (!Array.isArray(jobs) || jobs.length === 0) return null;

    // Filter jobs matching the given task name
    const matchingJobs = jobs.filter(job => job.task_name === taskName);

    // Get the last object in the filtered list
    if (matchingJobs.length > 0) {
      return matchingJobs[matchingJobs.length - 1];
    }

    return null; // Return null if no matching task
  }
  const getJobStatusofJob = (taskName) => {
    let obj = getTasksLastJob(taskName);
    return obj ? obj.job_status : '';
  }


  return (
    <TableContainer className="task-table-container" component={Paper}>
      <Typography className="tasks-header">Tasks</Typography>
      {
        tasksList && tasksList.length > 0 ?
          <Table>
            <TableHead>
              <TableRow>
                {/* <TableCell>ID</TableCell> */}
                <TableCell>Display Name</TableCell>
                <TableCell>Description</TableCell>
                <TableCell className="edit-delete-table-cell" >Status</TableCell>
                <TableCell className="edit-delete-table-cell" >Actions</TableCell>
                <TableCell className="edit-delete-table-cell" >Assign</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tasksList.map((task) => (
                <TableRow key={task.taskid} style={{ backgroundColor: task?.task_name == setectedAgentJobDetail?.current_job_name && (getJobStatusofJob(task?.task_name) == 'CANCELLED' || String(getJobStatusofJob(task?.task_name)).toLowerCase() == 'failed') ? '#fff0f0' : setectedAgentJobDetail?.current_job_id == getTasksLastJob(task?.task_name)?.job_id ? 'aliceblue' : '' }}>
                  {/* <TableCell>{task.taskid}</TableCell> */}
                  <TableCell>{task.task_display_name}</TableCell>
                  <TableCell>{task.task_description}</TableCell>
                  <TableCell>
                    <div className="flex align-items-center" style={{display:'flex'}}>
                  <div style={{width:'25px'}}>{getcurrentRunningJob(task).length > 0 ? getcurrentRunningJobIcon(getcurrentRunningJob(task)[0].job_status) : ''}</div>
                  <div>{(getcurrentRunningJob(task).length > 0 ? getcurrentRunningJob(task)[0].job_status : '').toUpperCase()}</div>
                  </div>
                  </TableCell>
                  <TableCell className="edit-delete-table-cell controller-cell">
                    {getcurrentRunningJob(task).length > 0 ? <>
                      <button type="button"
                        disabled={handleEnableCurrentRunningJob(task) || userRequests[task.task_name] == 'CANCEL' || userRequests[task.task_name] == 'COMPLETED'}
                        onClick={() => {
                          handleAgentStatus(userRequests[task.task_name], task)
                        }}
                        className={`agent-controller ${handleEnableCurrentRunningJob(task) || userRequests[task.task_name] == 'CANCEL' || userRequests[task.task_name] == 'COMPLETED' ? 'disabled-button' : ''}`}>
                        {handleEnableCurrentRunningJob(task) == 'DO' || handleEnableCurrentRunningJob(task) == 'PAUSE' ? handleEnableCurrentRunningJob(task) : userRequests[task.task_name] != 'CANCEL' && userRequests[task.task_name] != 'COMPLETED' && userRequests[task.task_name] ? userRequests[task.task_name] : 'DO'}
                      </button>
                      <button type="button"
                        disabled={handleEnableCurrentRunningJob(task) || userRequests[task.task_name] == 'CANCEL' || userRequests[task.task_name] == 'COMPLETED'}
                        onClick={() => {
                          handleAgentStatus('CANCEL', task)
                        }}
                        className={`task-cancel-button ${handleEnableCurrentRunningJob(task) || userRequests[task.task_name] == 'CANCEL' || userRequests[task.task_name] == 'COMPLETED' ? 'disabled-button' : ''}`}
                      >CANCEL
                      </button>
                    </> : ''}
                  </TableCell>
                  <TableCell className="edit-delete-table-cell">
                    <Button disabled={handleDisableAssignButton(task)} variant="contained" sx={{ mt: 1, mb: 1 }} onClick={() => handleOpen(task)}>{handleDisableAssignButton(task) == task.task_name ? 'Assigning' : 'Create'}</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          : <Typography className="empty-data">No Data Found</Typography>
      }

      <Modal className="task-modal-cotainer" open={open} onClose={handleClose}>
        <>
          {error?.type != '' &&
            <div className="error-message-container">  {/* Fixed typo */}
              <span className={`alert-message ${error.type === 'error' ? 'error-message' : error.type === 'success' ? 'success-message' : error.type === 'info' ? 'info-message' : ''}`}>
                {error?.message}
              </span>
            </div>

          }
          <Box className="modal-box-container">
            {/* Header */}

            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <Typography variant="h5" sx={{ textAlign: "center", flexGrow: 1 }}>
                Create Task
              </Typography>
              <FontAwesomeIcon icon={faTimes} onClick={handleClose} className="modal-close-button" />
            </Box>

            {/* Dynamic Input Fields */}

            <Box className="modal-input-grid">
              {selectedTask && Object.keys(selectedTask).length > 0 && selectedTask?.task_args && selectedTask?.task_args != null && Object.keys(selectedTask?.task_args).length > 0 && Object.entries(selectedTask?.task_args).map(([key, field]) => (
                <Box key={key} className={field.type === "multiline_string" ? "text-area-input-fields-box" : "input-fields-box"}>
                  <Typography className="modal-labels">{field.label}</Typography>

                  {/* Searchable Dropdowns (collectionId, datasetId, enum) */}
                  {["collectionId", "datasetId", "enum", "modelId",, "backendId"].includes(field.type) && (
                    <Autocomplete
                      options={field.options}
                      value={formData[key]}
                      onChange={(e, newValue) => handleInputChange(key, newValue)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={`Select ${field.label}`}
                          variant="outlined"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              fontSize: "14px",
                              padding: "8px",
                              borderRadius: "6px",
                              width: "90%",
                              borderRadius: "8px",
                              boxShadow: "0 2px 2px var(--input-shadow-color, #f2f2f2)",
                              transition: "border-color 0.2s, box-shadow 0.2s",
                              height: "39px",
                              "&:hover": { borderColor: "#888" },
                              "&.Mui-focused": { borderColor: "#1976d2" },
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "14px",
                              padding: "10px",
                            },
                            "& .MuiAutocomplete-popupIndicator": {
                              color: "#1976d2",
                            },
                          }}
                        />
                      )}
                    />
                  )}

                  {/* Text Inputs */}
                  {field.type === "string" && (
                    <input
                      className="styled-input"
                      placeholder={field.label}
                      value={formData[key]}
                      onChange={(e) => handleInputChange(key, e.target.value)}
                    />
                  )}

                  {/* Multi-line Text Input */}
                  {field.type === "multiline_string" && (
                    <textarea
                      className="styled-input styled-text-area"
                      rows={3}
                      placeholder={field.label}
                      value={formData[key]}
                      onChange={(e) => handleInputChange(key, e.target.value)}
                    />
                  )}

                  {/* Number Input */}
                  {field.type === "numerical" && (
                    <input
                      className="styled-input"
                      type="number"
                      value={formData[key]}
                      onChange={(e) => handleInputChange(key, e.target.value)}
                    />
                  )}

                  {/* Range Slider */}
                  {field.type === "ranged_numerical" && (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      {/* Min Value */}
                      <Typography variant="body2" sx={{ minWidth: "30px" }}>
                        {field.options[0]}
                      </Typography>

                      {/* Slider */}
                      <Slider
                        value={formData[key]}
                        min={field.options[0]}
                        max={field.options[1]}
                        step={0.1}
                        onChange={(e, newValue) => handleInputChange(key, newValue)}
                        valueLabelDisplay="auto"
                        sx={{ flexGrow: 1 }} // Allows slider to expand while labels remain fixed
                      />

                      {/* Max Value */}
                      <Typography variant="body2" sx={{ minWidth: "30px" }}>
                        {field.options[1]}
                      </Typography>
                    </div>
                  )}


                  {/* Checklist (Multiple Checkboxes) */}
                  {field.type === "checklist" && (
                    <Box>
                      {field.options.map((option) => (
                        <FormControlLabel
                          key={option}
                          control={
                            <Checkbox
                              checked={formData && formData[key] && formData[key].includes(option) || ''}
                              onChange={(e) => {
                                let formDataKeyList = formData && Object.keys(formData).length > 0 && formData[key] && formData[key].length > 0 ? formData[key] : []
                                const newSelection = e.target.checked
                                  ? [...formDataKeyList, option]
                                  : formData[key].filter((item) => item !== option);
                                handleInputChange(key, newSelection);
                              }}
                            />
                          }
                          label={option}
                        />
                      ))}
                    </Box>
                  )}
                </Box>
              ))}
            </Box>

            {/* Submit Button */}
            <Box className="submit-button-container">
              <Button variant="contained" onClick={handleAssignTask}>
                Assign Task
              </Button>
            </Box>
          </Box>
        </>

      </Modal>
    </TableContainer>
  );
};